import { FormGroup } from "@angular/forms";

export function camposFaltantes(form: FormGroup, nombres: { [control: string]: string }): string {
  form.markAllAsTouched();
  const faltan = Object.keys(nombres)
    .filter((control) => form.get(control)?.invalid)
    .map((control) => nombres[control]);
  return faltan.length
    ? "Completá los campos obligatorios: " + faltan.join(", ")
    : "Revisá los datos marcados en el formulario";
}

export function mensajeError(err: any, porDefecto: string): string {
  const cuerpo = err?.error;
  if (err?.status < 400 || err?.status >= 500 || !cuerpo) {
    return porDefecto;
  }
  return [cuerpo.message, cuerpo.error, cuerpo.mensaje].find((m) => typeof m === "string" && m) || porDefecto;
}
